var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: { table_title: _vm.table_title },
    scopedSlots: _vm._u([
      {
        key: "datetime",
        fn: function() {
          return [
            _c("QpeDatetime", {
              attrs: {
                props_date: _vm.date,
                props_time: _vm.time,
                name: _vm.default_value
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "data_table",
        fn: function(slot_props) {
          return [
            _c("QpeDatatable", {
              staticClass: "realtime_echo",
              attrs: {
                data: _vm.table_data,
                headers: _vm.header,
                name: _vm.default_value,
                error_text: _vm.error_text,
                props_date: _vm.date,
                props_time: _vm.time,
                search: slot_props.search,
                should_show_raw_html_header: _vm.should_show_raw_html_header,
                custom_header: true,
                show_table_border: true,
                show_download_pdf_btn: true
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "table_description",
                    fn: function() {
                      return [
                        _c("span", [
                          _vm._v("\n                        說明："),
                          _c("br"),
                          _vm._v(
                            "\n                        1.警示條件：表示待命區範圍內的雷達回波大於及等於30dBZ且占待命區面積達60%以上。"
                          ),
                          _c("br"),
                          _vm._v("\n                        紅燈: "),
                          _c("span", {
                            staticClass: "description-dot",
                            staticStyle: { background: "#FF0000" }
                          }),
                          _vm._v("：達警示標準"),
                          _c("br"),
                          _vm._v("\n                        綠燈: "),
                          _c("span", {
                            staticClass: "description-dot",
                            staticStyle: { background: "#00FF00" }
                          }),
                          _vm._v("：未達警示標準"),
                          _c("br"),
                          _vm._v("   \n                        --: 無資料"),
                          _c("br"),
                          _vm._v(
                            "\n                        2.即時回波警示：使用即時觀測的雷達整合回波，以上述警示條件進行警示。 "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                        3.預報回波警示 ：使用最近3報且預報相同目標時間的模式回波，以上述警示條件進行警示。 "
                          ),
                          _c("br")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }